<script setup lang="ts">
import { cn } from '@/components/lib/shadcn-vue/utils';

import type { HTMLAttributes } from 'vue';
interface SkeletonProps {
  class?: HTMLAttributes['class'];
}
const props = defineProps<SkeletonProps>();
</script>

<template>
  <div :class="cn('animate-pulse rounded-md bg-beige3 opacity-60', props.class)" />
</template>
